import { Component, ElementRef, EventEmitter, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { ModalType } from 'src/app/core/enums/modalTypesEnum';
import { AddressModel } from 'src/app/core/models/address.model';
import { InsuranceCompany } from 'src/app/core/models/members/client/insurance-company.model';
import { ImportCountResult } from 'src/app/core/models/push/import-count-result';
import { Menu } from 'src/app/core/models/system/menu';
import { MenuItem } from 'src/app/core/models/system/menu-item';
import { LoginType } from 'src/app/core/models/members/user/user-context.model';
import { AuthMyfileService } from 'src/app/core/services/auth.myfile.service';
import { BadgeCountService } from 'src/app/core/services/badgecount.service';
import { ClientModalService } from 'src/app/core/services/modal-services/client-modal.service';
import { ContactModalService } from 'src/app/core/services/modal-services/contact-modal.service';
import { InviteModalService } from 'src/app/core/services/modal-services/invite-modal.service';
import { MyfileApiService } from 'src/app/core/services/myfile-api.service';
import { PreferenceService, PreferenceType } from 'src/app/core/services/preference.service';
import { GlobalComponent } from 'src/app/global-component';

@Component({
  selector: 'app-base-layout',
  templateUrl: './base-layout.component.html',
  styleUrls: ['./base-layout.component.scss']
})
export class BaseLayoutComponent implements OnInit, OnDestroy {
  menu: any;
  menuItems: MenuItem[] = [];

  importCount:ImportCountResult | undefined = new ImportCountResult;
  @ViewChild('sideMenu') sideMenu!: ElementRef;
  @Output() mobileMenuButtonClicked = new EventEmitter();

  // private fields
  private unsubscribe: Subscription[] = [];

  constructor(
    protected router: Router,
    protected myContactModalService: ContactModalService,
    protected myClientModalService: ClientModalService,
    protected myInviteModalService: InviteModalService,
    protected myfileApiService: MyfileApiService,
    protected userPreferenceService: PreferenceService,
    protected badgeCountService: BadgeCountService,
    protected authMyFileService: AuthMyfileService) {
    this.router.events.subscribe((val: any) => {
      if (val && val.type == 1) {
        this.initActiveMenu();
      }
    });
  }

  ngOnInit(): void {
    this.userPreferenceService.currentPreference
      .subscribe((data: PreferenceType) => {
        if (data) {
          this.menuItems = Menu.getMenuItems(this.authMyFileService,this.userPreferenceService);
        }
      });
      
    this.badgeCountService.badgeCountUpdated$.subscribe((badgeCount=>{
        if(badgeCount){
          this.importCount = badgeCount.importEntityCount;
        }
      }))  
  }

  ngOnDestroy() {
    this.unsubscribe.forEach((sb) => sb.unsubscribe());
  }

  ngAfterViewInit() {
    this.initActiveMenu();
  }

  initActiveMenu() {
    const pathName = window.location.pathname;
    const ul = document.getElementById("navbar-nav");
    if (ul) {
      const items = Array.from(ul.querySelectorAll("a.nav-link"));
      let activeItems = items.filter((x: any) => x.classList.contains("active"));
      this.removeActivation(activeItems);

      let matchingMenuItem = items.find((x: any) => {
        return x.pathname === pathName;
      });
      if (matchingMenuItem) {
        this.activateParentDropdown(matchingMenuItem);
      }
    }
  }

  activateParentDropdown(item: any) { // navbar-nav menu add active

    item.classList.add("active");
    let parentCollapseDiv = item.closest(".collapse.menu-dropdown");
    if (parentCollapseDiv) {

      // to set aria expand true remaining
      parentCollapseDiv.classList.add("show");
      parentCollapseDiv.parentElement.children[0].classList.add("active");
      parentCollapseDiv.parentElement.children[0].setAttribute("aria-expanded", "true");

      if (parentCollapseDiv.parentElement.closest(".collapse.menu-dropdown")) {
        parentCollapseDiv.parentElement.closest(".collapse").classList.add("show");
        if (parentCollapseDiv.parentElement.closest(".collapse").previousElementSibling) {

          parentCollapseDiv.parentElement.closest(".collapse").previousElementSibling.classList.add("active");
          parentCollapseDiv.parentElement.closest(".collapse").previousElementSibling.setAttribute("aria-expanded", "true");
        }
      }
      return false;
    }
    return false;
  }



  removeActivation(items: any) {
    items.forEach((item: any) => {
      if (item.classList.contains("menu-link")) {
        if (!item.classList.contains("active")) {
          item.setAttribute("aria-expanded", false);
        }
        (item.nextElementSibling) ? item.nextElementSibling.classList.remove("show") : null;
      }
      if (item.classList.contains("nav-link")) {
        if (item.nextElementSibling) {
          item.nextElementSibling.classList.remove("show");
        }
        item.setAttribute("aria-expanded", false);
      }
      item.classList.remove("active");
    });
  }

  updateActive(event: any, modalType?: any) {
    const ul = document.getElementById("navbar-nav");
    if (ul) {
      const items = Array.from(ul.querySelectorAll("a.nav-link"));
      this.removeActivation(items);
    }
    this.activateParentDropdown(event.target);

    if (modalType != null) {

      switch ((modalType)) {

        case ModalType.ContactModal:
          this.myContactModalService.openModal();
          break;
        case ModalType.ClientModal:
          if (this.authMyFileService.currentUserContextValue?.loginType == LoginType.Client) {
            this.myfileApiService.getClient().subscribe((clientModel) => {
              if (clientModel) {
                if (clientModel.address == (null || undefined)) {
                  clientModel.address = new AddressModel();  //used for legacy clients. 
                }
                if (clientModel.opposingCounsel.address == (null || undefined)) {
                  clientModel.opposingCounsel.address = new AddressModel();
                }
                if (clientModel.insuranceCompany == (null || undefined)) {
                  clientModel.insuranceCompany = new InsuranceCompany();
                }

                //used to transform the date if the modal has one to the DD/MM/YYYY format
                if (clientModel.dateOfBirth != null) {
                  clientModel.dateOfBirth = GlobalComponent.dateTransform(clientModel.dateOfBirth, false);
                }
                if (clientModel.dateOfLoss != undefined) {
                  clientModel.dateOfLoss = GlobalComponent.dateTransform(clientModel.dateOfLoss, false);
                }
              }
              this.myClientModalService.openModal(clientModel);
            })
          } else {
            this.myClientModalService.openModal();
          }
          break;
        case ModalType.InviteClient:
          this.myInviteModalService.openModal(LoginType.Client);
          break;
        case ModalType.InviteUser:
          this.myInviteModalService.openModal(LoginType.User);
          break;

      }
    }
  }
  /**
  * Returns true or false if given menu item has child or not
  * @param item menuItem
  */
  hasItems(item: MenuItem) {
    return item.subItems !== undefined ? item.subItems.length > 0 : false;
  }

}
